<template>
    <div class="jump-warphd nav-bar-fixed" >
        <van-nav-bar title="月结账单审批" left-arrow fixed @click-left="back"/>
        <van-tabs v-model="tabActive" class="appr-tabs" >
            <van-tab title="审批导入明细">
                <van-cell-group title="审批流信息">
                    <van-cell title="审批类型" :value="workflow.workFlowTypeName" />
                    <van-cell title="申请时间" :value="workflow.createtime"  />
                    <van-cell title="停滞时间" :value="workflow.deadTime"  />
                </van-cell-group>
                <van-cell-group title="基础信息">
                    <van-cell title="审核状态" :value="checkStatus" />
                    <van-cell title="所属分公司" :value="milkImport.org_name"  />
                    <van-cell title="月结时间" :value="milkImport.import_time"  />
                </van-cell-group>
                <van-cell-group title="审批日志" v-if="workflowLog">
                    <div class="pay-by">
                    <div v-for="item in workflowLog">
                        <div class="pay-item ok" v-if="item.status">
                            <van-row>
                                <van-col span="12">
                                    <p>{{item.createtime}}</p>
                                </van-col>
                                <van-col span="12" class="text-center">
                                    <p>{{item.cost_time}}</p>
                                </van-col>
                            </van-row>
                            <van-row class="pay-item-ft">
                                <van-col span="24">
                                    <p>{{item.remark}}</p>
                                </van-col>
                                <van-col span="24" class="text-right">
                                    <p><span>审批人：</span>{{item.trueName}}</p>
                                    <p><span>审批状态：</span>{{item.status_name}}</p>
                                </van-col>
                            </van-row>
                            <div class="pay-item-rd"></div>
                        </div>

                        <div class="pay-item err" v-if="!item.status">
                            <van-row>
                                <van-col span="12">
                                    <p>{{item.createtime}}</p>
                                </van-col>
                                <van-col span="12" class="text-center">
                                    <p>{{item.cost_time}}</p>
                                </van-col>
                            </van-row>
                            <van-row class="pay-item-ft">
                                <van-col span="24">
                                    <p>{{item.remark}}</p>
                                </van-col>
                                <van-col span="24" class="text-right">
                                    <p><span>审批人：</span>{{item.trueName}}</p>
                                    <p><span>审批状态：</span> <span style="color: #ffc107;">{{item.status_name}}</span></p>
                                </van-col>
                            </van-row>
                            <div class="pay-item-rd"></div>
                        </div>
                    </div>
                   </div>
                </van-cell-group>
                <van-cell-group title="导入明细">
                    <van-collapse v-model="activeNames" accordion>
                        <van-collapse-item   :title="importItem.goodsName" :name="importIndex" :key="importIndex" v-for="(importItem,importIndex) in importDetail">
                            <van-cell title="牧场名称" :value="importItem.mcmc"  />
                            <van-cell title="数量" :value="importItem.count"  />
                            <van-cell title="金额" :value="importItem.price"  />
                            <van-cell title="上月欠款" :value="importItem.lastMonthArrear"  />
                            <van-cell title="本月回款" :value="importItem.thisMonthReturn"  />
                            <van-cell title="本月欠款" :value="importItem.thisMonthArrear"  />
                            <van-cell title="备注" :value="importItem.remark"  />
                        </van-collapse-item>
                    </van-collapse>
                </van-cell-group>
                <van-cell-group title="审核" v-if="workflow.status==0&&actionStatus=='false'">
                    <van-row >
                        <van-col span="24" class="textareaBox">
                            <van-field type="textarea" v-model="remark" />
                        </van-col>
                        <van-col span="12" style="margin-top: 10px;text-align: center">
                            <van-button type="info" size="small" @click="savedeal(1)">通过</van-button>
                        </van-col>
                        <van-col span="12" style="margin-top: 10px">
                            <van-button type="danger" size="small" class="danger" @click="savedeal(0)">驳回</van-button>
                        </van-col>
                    </van-row>
                </van-cell-group>
            </van-tab>
            <van-tab title="用户确认明细">
                <van-collapse v-model="importMemberConfirmActive" accordion>
                    <van-collapse-item v-for="(memberConfirmItem,memberConfirmIndex) in memberConfirmList" :key="memberConfirmIndex" :title="memberConfirmItem.mcmc" :name="memberConfirmIndex">
                        <van-cell title="牧场编号" :value="memberConfirmItem.pastureID" />
                        <van-cell title="牧场名称" :value="memberConfirmItem.mcmc"  />
                        <van-cell title="确认时间" :value="memberConfirmItem.confirmTime"  />
                        <van-cell title="账单状态" :value="memberConfirmItem.statusName"  />
                        <van-cell title="客户意见" :value="memberConfirmItem.remark"  />
                        <van-cell title="还款明细" >
                            <van-button type="info" size="small" @click="showDetail(memberConfirmIndex)">查看明细</van-button>
                        </van-cell>
                        <van-cell title="关闭账单" value="100000"  v-if="memberConfirmItem.isCloseShow || memberConfirmItem.payStatus!=2">
                            <van-button type="danger" size="small" @click="showClose(memberConfirmIndex)">关闭账单</van-button>
                        </van-cell>
                    </van-collapse-item>

                </van-collapse>
            </van-tab>
            <van-tab title="导入汇总明细">
                <van-collapse v-model="importSummaryActive" accordion>
                    <van-collapse-item v-for="(importSummaryItem,summaryIndex) in importSummary" :key="summaryIndex" :title="importSummaryItem.pastureID" :name="summaryIndex" >
                        <van-cell title="牧场编号" :value="importSummaryItem.pastureID" />
                        <van-cell title="商品消费总金额" :value="importSummaryItem.price"  />
                        <van-cell title="上月欠款" :value="importSummaryItem.lastMonthArrear"  />
                        <van-cell title="本月回款" :value="importSummaryItem.thisMonthReturn"  />
                        <van-cell title="本月欠款" :value="importSummaryItem.thisMonthArrear"  />
                    </van-collapse-item>

                </van-collapse>
            </van-tab>
        </van-tabs>
        <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
            <div class="closeRemark">
                <van-row>
                    <van-button type="info" class="left" @click="hideClose"  size="small">取消</van-button>
                    <van-button type="info" class="right" @click="closeMilk" size="small">确认</van-button>
                </van-row>
                <van-row>
                    <van-field type="textarea" class="closeTextarea" placeholder="请输入关闭账单原因" v-model="remark" />
                </van-row>
            </div>
        </van-popup>

    </div>
</template>
<script>
    import {
        NavBar, Cell, CellGroup, Field, Button, Row, Col, Collapse, CollapseItem, Tabs, Tab, Switch, Picker,
        Popup, RadioGroup, Radio, DatetimePicker, Dialog, Uploader
    } from "vant";

    export default {
        name: "ApprovalDetail",
        components: {
            [Dialog.name]: Dialog,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [Popup.name]: Popup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [Switch.name]: Switch,
            [Uploader .name]: Uploader ,
        },
        data() {
            return {
                workflowId:'',
                workflow:{},//审批
                importDetail:[],//导入详情
                workflowLog:[],//审批记录
                memberConfirmList:[],//用户确认列表
                importSummary:[],//导入汇总信息
                tabActive:0,
                checkStatus:"审批中",
                activeNames:[],
                importSummaryActive:[],
                importMemberConfirmActive:[],
                milkImport:{},//导入基本信息
                remark:"",//审批备注
                show:false,
                showIndex:-1,
                actionStatus:localStorage.getItem('actionStatus')
            }

        },
        mounted() {
            let that = this;
            that.workflowId=localStorage.getItem('workflow_id');
            that.loadWorkflowInfo();
            that.loadImportDetailFunc();
            that.loadMemberConfirmListFunc();
            that.loadImportSummaryFunc();
        },
        methods: {
            loadWorkflowInfo(){//加载流程信息
                let that = this;
                that.$api.get(that.jumuc.milk.milkWorkflowDetail,{'workFlow_id':that.workflowId,'flag':true},res => {
                   if(res && res.success){
                        that.workflowLog=res.data.workflowLog;
                        that.workflow=res.data.workFlow;
                        if(that.workflow.status!=0){
                            that.checkStatus="审批通过";
                        }
                        that.milkImport=res.data.milkImport;
                    }
                })
            },
            loadImportDetailFunc(){//加载导入明细
                let that = this;
                that.$api.get(that.jumuc.milk.loadImportDetail,{'workFlow_id':that.workflowId,'flag':true},res => {
                    if(res.success){
                        that.importDetail=res.data;
                    }
                })
            },
            loadMemberConfirmListFunc(){//确认明细
                let that = this;
                that.$api.get(that.jumuc.milk.memberConfirmList,{'workFlow_id':that.workflowId,'flag':true},res => {
                    if(res.success){
                        that.memberConfirmList=res.data;
                    }
                })
            },
            loadImportSummaryFunc(){
                let that = this;
                that.$api.get(that.jumuc.milk.importSummary,{'workFlow_id':that.workflowId,'flag':true},res => {
                    if(res.success){
                        that.importSummary=res.data;
                    }
                })
            },
            back(){
                history.back();
            },
            savedeal(status) {
                let that = this;
                if (status == 0 && !that.remark) {
                    Dialog.alert({
                        message: "驳回内容不能为空"
                    });
                    return;
                }
                that.$api.post(that.jumuc.stock.savedeal, {
                    milkImportId: that.milkImport.id,
                    workflowId: that.workflowId,
                    currentSquence: that.workflow.currentSquence,
                    status: status,
                    remark: that.remark
                }, res => {
                    Dialog.alert({
                        message: res.msg
                    }).then(() => {
                            that.$router.push({
                                path: '/staff/approval'
                            });
                        });
                })
            },
            showDetail(index){
                localStorage.setItem("workflowImportConfirmId",this.memberConfirmList[index].id);
                 this.$router.push({path: '/staff/approval/milkRepaymentDetail'});
            },
            closeMilk(){
                let that = this;

                if(that.remark=='' || that.showIndex==-1){
                    Dialog.alert({
                        message: '关闭账单必须输入关闭原因'
                    });
                    return;
                }
                let index=that.showIndex;
                that.show=false;
                that.$api.get(that.jumuc.milk.closeMilk, {
                    importConfirmId: that.memberConfirmList[index].id,
                    closeRemark:that.remark
                }, res => {
                    if(res.success){
                        that.loadMemberConfirmListFunc();
                    }
                    Dialog.alert({
                        message: res.msg
                    });
                })
            },
            showClose(index){
                this.show=true;
                this.showIndex=index;
            },
            hideClose(){
                this.show=false
                this.showIndex=-1;
                this.remark='';
            }

        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3C6EEB;
    body {
        background: #f7f7ff;
    }
    .closeRemark .right{
        position: absolute;
        right: 10px;
        top: 5px;
    }
    .closeRemark .left{
        position: absolute;
        left: 10px;
        top: 5px;
    }
    .closeRemark .closeTextarea{
        width: 95%!important;
        border: 1px #C2C2C2 solid;
        margin-left: 2.5%!important;
        margin-top: 10%;
    }
    .textareaBox{
        width: 95%!important;
        border: 1px #C2C2C2 solid;
        margin-left: 2.5%!important;
    }
    #app .van-tabs__line {
        height: 45px;
        background-color: rgba(255, 255, 255, 0.1);
        min-width: 100px;
        left: -20px;
    }

    .appr-tabs {
        .van-tab {
            color: #fff;
        }
        .van-tabs__nav {
            background-color: @bule-thame;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
    }
    .pay-by {
        padding: 10px;
        .pay-item {
            background-color: #fff;
            padding: 10px;
            position: relative;
            margin-bottom: 10px;
            p {
                color: #ccc;
                font-size: 12px;
                padding: 5px 0;
            }
            &-ft {
                padding-top: 10px;
                p {
                    color: #333;
                }
            }
            .pay-state {
                text-align: right;
                color: @bule-thame;
                i {
                    display: inline-block;
                    padding: 5px;
                    border-radius: 100%;
                    background-color: @bule-thame;
                }
            }
            &-rd {
                position: absolute;
                top: 0;
                left: -5px;
                width: 10px;
                height: 100%;
                background-color: @bule-thame;
                border-radius: 10px 0 0 10px;
            }

            &.ok {
                .pay-state {
                    color: #28a745;
                    i {
                        background-color: #28a745;
                    }
                }
                .pay-item-rd {
                    background-color: #28a745;
                }
            }
            &.err {
                .pay-state {
                    color: #ffc107;
                    i {
                        background-color: #ffc107;
                    }
                }
                .pay-item-rd {
                    background-color: #ffc107;
                }
            }
        }
    }
</style>
